import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TermsAndConditionsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-black py-12 px-4 sm:px-6 lg:px-8 text-gray-300">
      <div className="max-w-4xl mx-auto">
        {/* Botón para volver */}
        <button
          onClick={() => navigate(-1)} // Vuelve a la página anterior
          className="mb-6 inline-flex items-center gap-2 text-purple-300 hover:text-purple-200 transition-colors"
        >
          <ArrowLeft size={18} />
          <span>Volver</span>
        </button>

        {/* Contenedor principal con estilo */}
        <div className="bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 p-6 sm:p-10 shadow-lg">
          <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-blue-400 mb-6 text-center">
            TÉRMINOS Y CONDICIONES DE USO - CURVIA AI
          </h1>
          <p className="text-sm text-gray-400 mb-8 text-center">
            Fecha de última actualización: 01-04-2025
          </p>

          <div className="prose prose-invert prose-sm sm:prose-base max-w-none prose-headings:text-purple-300 prose-strong:text-purple-200 prose-ul:list-disc prose-ul:pl-6 prose-li:my-1 space-y-4">
            <p>
              Bienvenido a Curvia AI. Estos términos y condiciones (“Términos”) regulan el uso de nuestra plataforma de generación de currículums mediante inteligencia artificial. Al acceder o utilizar Curvia AI, el usuario acepta cumplir con estos Términos.
            </p>

            <h2>1. DEFINICIONES</h2>
            <ul>
              <li><strong>“Curvia AI”</strong> se refiere a la plataforma que genera currículums optimizados mediante inteligencia artificial.</li>
              <li><strong>“Usuario”</strong> hace referencia a cualquier persona que acceda o utilice nuestros servicios.</li>
              <li><strong>“Servicio”</strong> hace referencia a la generación de currículums, cartas de presentación y análisis de oportunidades y debilidades laborales.</li>
            </ul>

            <h2>2. USO DEL SERVICIO</h2>
            <p>
              El usuario acepta utilizar Curvia AI de manera responsable y conforme a la ley. Se prohíbe estrictamente el uso del servicio para:
            </p>
            <ul>
              <li>Crear información falsa o engañosa en currículums.</li>
              <li>Reproducir, modificar o distribuir el contenido generado sin autorización.</li>
              <li>Intentar acceder, manipular o hackear nuestros sistemas.</li>
              <li>Usar el servicio de manera que pueda afectar su disponibilidad para otros usuarios.</li>
            </ul>
            <p>
              Nos reservamos el derecho de suspender cuentas sin reembolso en caso de detectar abuso o uso fraudulento.
            </p>

            <h2>3. NO RESPONSABILIDAD POR DECISIONES DE EMPLEO</h2>
            <ul>
              <li>Curvia AI no garantiza que el usuario consiga empleo.</li>
              <li>Las decisiones de contratación dependen de cada empleador, y el usuario es responsable de verificar la información de su currículum antes de enviarla.</li>
            </ul>

            <h2>4. PRECIO, PAGOS Y CAMBIOS EN EL SERVICIO</h2>
            <ul>
              <li>Curvia AI se reserva el derecho de modificar precios, planes o funciones en cualquier momento, sin previo aviso.</li>
              <li>Si el usuario no está de acuerdo con los cambios, su única opción es dejar de usar el servicio.</li>
            </ul>

            <h2>5. REEMBOLSOS</h2>
            <ul>
              <li>Curvia AI solo realizará reembolsos en caso de errores del sistema.</li>
              <li>Para solicitar un reembolso, el usuario deberá guardar el código de transacción o boleta y proporcionarlo para la trazabilidad del caso.</li>
              <li>No se realizarán reembolsos por mal uso del servicio o insatisfacción con los resultados.</li>
            </ul>

            <h2>6. USO DE INTELIGENCIA ARTIFICIAL Y POSIBLES ERRORES</h2>
            <ul>
              <li>La generación de contenido es automática y puede contener errores o inexactitudes.</li>
              <li>Curvia AI no es un servicio de asesoría profesional, por lo que el usuario es responsable de revisar la información antes de su uso.</li>
            </ul>

            <h2>7. PRIVACIDAD Y USO DE DATOS</h2>
            <ul>
              <li>Curvia AI NO recopila ni almacena información personal de los usuarios para uso comercial ni para reentrenamiento de modelos de IA.</li>
              <li>La información ingresada en la plataforma se procesa únicamente para generar el currículum y no se utiliza con otros fines.</li>
              <li>Cumplimos con normativas de protección de datos como GDPR (Europa) y la Ley de Protección de Datos Personales en Chile.</li>
            </ul>

            <h2>8. SOPORTE Y RESPONSABILIDAD DEL SERVICIO</h2>
            <ul>
              <li>Ofrecemos soporte técnico “según disponibilidad” y no garantizamos tiempos de respuesta inmediatos.</li>
              <li>El usuario reconoce que pueden ocurrir fallas técnicas, interrupciones o errores en el servicio, y Curvia AI no se hace responsable por pérdidas económicas derivadas de estos.</li>
            </ul>

            <h2>9. JURISDICCIÓN Y LEY APLICABLE</h2>
            <p>
              Estos Términos se rigen por las leyes de Chile. Cualquier disputa deberá resolverse en tribunales de Santiago de Chile.
            </p>

            <p className="mt-6 font-semibold">
              Al utilizar Curvia AI, el usuario confirma haber leído y aceptado estos términos.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage; 